import { InjectionToken } from '@angular/core';

export interface SharedConfig {
    passportHelpServiceUrl: string;
    helpServiceUrl: string;
    redirectFeedback: boolean;
    subscriberServiceUrl: string;
    apiBaseUrl: string;
}

export const SHARED_CONFIG = new InjectionToken<SharedConfig>('SharedConfig');
